export const BASE_URL = process.env.REACT_APP_API_URL;
export const CASE_URL = process.env.REACT_APP_API_CASE_URL;